import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'https://dev.api.gioallday.com';

const authHeaders = (token: string) => ({
  Authorization: `Bearer ${token}`,
  'Content-Type': 'application/json'
});

export type LocalizationTranslations = {
  en?: string | null;
  es?: string | null;
  pt?: string | null;
  zh?: string | null;
};

export type LocalizationKeyItem = {
  key: string;
  translations: LocalizationTranslations;
};

export type LocalizationManageResponse = {
  version: number;
  total: number;
  items: LocalizationKeyItem[];
};

export type LocalizationVersionsResponse = {
  latest: number | null;
  total: number;
  items: {
    version: number;
    note: string | null;
    created_at: string;
  }[];
};

export type LocalizationMutationResponse = {
  key: string;
  translations: LocalizationTranslations;
  version: number;
  created_at: string;
};

export type LocalizationReplaceResponse = {
  language: string;
  version: number;
  created_at: string;
  key_count: number;
  note?: string;
};

export const localizationApi = {
  listKeys: (token: string) =>
    axios.get<LocalizationManageResponse>(
      `${API_URL}/api/localizations/manage`,
      { headers: authHeaders(token) }
    ),

  listVersions: (token: string) =>
    axios.get<LocalizationVersionsResponse>(
      `${API_URL}/api/localizations/versions`,
      { headers: authHeaders(token) }
    ),

  createKey: (
    token: string,
    body: { key: string; en?: string; es?: string; pt?: string; zh?: string }
  ) =>
    axios.post<LocalizationMutationResponse>(
      `${API_URL}/api/localizations`,
      body,
      { headers: authHeaders(token) }
    ),

  updateKey: (
    token: string,
    key: string,
    body: { en?: string; es?: string; pt?: string; zh?: string }
  ) =>
    axios.patch<LocalizationMutationResponse>(
      `${API_URL}/api/localizations/${encodeURIComponent(key)}`,
      body,
      { headers: authHeaders(token) }
    ),

  removeKey: (token: string, key: string) =>
    axios.delete<{
      key: string;
      removed_from_latest: boolean;
      version: number;
      created_at: string;
    }>(`${API_URL}/api/localizations/${encodeURIComponent(key)}`, {
      headers: authHeaders(token)
    }),

  replaceLanguage: (
    token: string,
    body: { language: 'en' | 'es' | 'pt' | 'zh'; strings: Record<string, string> }
  ) =>
    axios.post<LocalizationReplaceResponse>(
      `${API_URL}/api/localizations/replace`,
      body,
      { headers: authHeaders(token) }
    )
};
